// app/frontend/pages/Users/ManagedOrganizations.tsx
import React from 'react';
import { Container, Group, Title, Text, Card, Button, Badge, Stack, List } from '@mantine/core';
import { Link } from '@inertiajs/react';

interface Subscriber {
  username: string;
}

interface Organizer {
  id: number;
  name: string;
  slug: string;
  subscribers_count: number; // you may already have this count on the organizer object
  subscribers: Subscriber[]; // array of { username }
}

interface ManagedOrganizationsProps {
  organizers: Organizer[];
}

const ManagedOrganizations: React.FC<ManagedOrganizationsProps> = ({ organizers }) => {
  return (
    <Container>
      <Card shadow="sm" p="lg" radius="sm" style={{ marginBottom: '1rem', backgroundColor: '#75757550' }}>
        <Group justify="space-between" align="center">
          <div>
            <Title order={3} className="text-white">
              Organizations You Manage
            </Title>
            <Text size="sm" c="dimmed">
              Manage your organizations here!
            </Text>
          </div>
          <Button component={Link} href="/suggest_organizer" variant="filled">
            Add New Organization
          </Button>
        </Group>
      </Card>

      {organizers.length > 0 && (
        <Card shadow="sm" p="lg" radius="md" style={{ marginBottom: '1rem', backgroundColor: '#75757550' }}>
          <Group justify="space-between" align="center" mb="md">
            <Title order={4} style={{ margin: 0 }} className="text-white">
              Organizations{' '}
              <Badge color="yellow" variant="filled">
                {organizers.length}
              </Badge>
            </Title>
          </Group>

          <Stack gap="md">
            {organizers.map((org) => (
              <Card key={org.id} shadow="xs" p="md" radius="sm" style={{ backgroundColor: '#757575' }}>
                <Group justify="space-between" align="flex-start">
                  <Button component={Link} href={`/o/${org.slug}`} variant="filled">
                    {org.name}
                  </Button>

                  <div>
                    <Text size="sm" c="white">
                      Subscribers:
                    </Text>
                    <Badge color="yellow" variant="light" mt={4}>
                      {org.subscribers_count}
                    </Badge>
                  </div>
                </Group>

                {org.subscribers.length > 0 && (
                  <List withPadding size="sm" mt="sm" c="white">
                    {org.subscribers.map((sub) => (
                      <List.Item key={sub.username}>{sub.username}</List.Item>
                    ))}
                  </List>
                )}
              </Card>
            ))}
          </Stack>
        </Card>
      )}
    </Container>
  );
};

export default ManagedOrganizations;
